// extracted by mini-css-extract-plugin
export default {"textarea":"---------packages-corgi-x-src-components-TextArea-TextArea-module__textarea","fieldLabel":"---------packages-corgi-x-src-components-TextArea-TextArea-module__fieldLabel"};